<script>
import store from '@state/store'
import axios from 'axios'
import { socials } from '@utils/form'

let id = 0

export default {
  components: {},
  data() {
    return {
      loaded: false,
      figment: null,
      socials: socials,
    }
  },
  mounted() {
    this.figment = store.getters['figments/selectedFigment']
    this.loaded = true
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'dynamic_form_item' })
    this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
  },
  methods: {
    add() {
      const { form } = this
      // can use data-binding to get
      const keys = form.getFieldValue('keys')
      const nextKeys = keys.concat(id++)
      // can use data-binding to set
      // important! notify form to detect changes
      form.setFieldsValue({
        keys: nextKeys,
      })
    },
    removeItem(id) {
      const { form } = this
      const keys = form.getFieldValue('keys')
      const nextKeys = keys.filter((i) => i !== id)
      form.setFieldsValue({
        keys: nextKeys,
      })
    },
    doCopy(field) {
      this.form.validateFields((_err, values) => {
        const text = values[field]
        this.$copyText(text).then(
          () => {
            this.$notification.success({
              message: `Field Copied!`,
              duration: 2,
            })
          },
          () => {
            this.$notification.error({
              message: `Failed to Copy`,
              duration: 2,
            })
          }
        )
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          let oldAccounts
          if (values.accounts_platform) {
            oldAccounts = values?.accounts_platform?.length
              ? values.accounts_platform.map((k, i) => {
                  return {
                    platform:
                      values.accounts_platform[i] ||
                      this.figment.meta.accounts[i].platform,
                    platform_dateActivated:
                      values.accounts_platform_dateActivated[i] ||
                      this.figment.meta.accounts[i].platform_dateActivated,
                    platform_dateInactivated:
                      values.accounts_platform_dateInactivated[i] ||
                      this.figment.meta.accounts[i].platform_dateInactivated,
                    platform_notes:
                      values.accounts_platform_notes[i] ||
                      this.figment.meta.accounts[i].platform_notes,
                    platform_password:
                      values.accounts_platform_password[i] ||
                      this.figment.meta.accounts[i].platform_password,
                    platform_status: values.accounts_platform_status[i],
                    platform_username:
                      values.accounts_platform_username[i] === 'undefined'
                        ? this.figment.meta.accounts[i].platform_username
                        : values.accounts_platform_username[i],
                  }
                })
              : []
          } else {
            oldAccounts = this.figment.meta.accounts
          }

          const newAccounts =
            values?.keys?.map((key) => {
              return {
                platform: values.platform[key],
                platform_dateActivated: values.platform_dateActivated[key],
                platform_dateInactivated: values.platform_dateInactivated[key],
                platform_notes: values.platform_notes[key],
                platform_password: values.platform_password[key],
                platform_status: values.platform_status[key],
                platform_username: values.platform_username[key],
              }
            }) || []

          this.figment.meta.accounts = [...oldAccounts, ...newAccounts]

          axios
            .put(
              process.env.VUE_APP_KONSUL_API_URL + '/figments',
              this.figment,
              {
                headers: {
                  Authorization: 'Bearer ' + this.$auth.user.access_token,
                },
              }
            )
            .then(
              (res) => {
                this.figment = res.data
                this.form = this.$form.createForm(this, {
                  name: 'dynamic_form_item',
                })
                this.form.getFieldDecorator('keys', {
                  initialValue: [],
                  preserve: true,
                })
                this.$notification.success({
                  message: `${
                    res?.data?.meta?.name || 'Figment'
                  } Successfully Updated`,
                })
                store.commit('figments/SET_FIGMENT', this.figment)
              },
              () => {
                this.$notification.error({
                  message: 'Failed to Update Figment',
                })
              }
            )
        } else {
          this.$notification.error({
            message: 'Please correct the errors in your form!',
          })
        }
      })
    },
  },
}
</script>

<template>
  <div class="accounts--container">
    <div v-if="!loaded" class="loader">
      <a-icon
        type="loading"
        style="padding-left: 8px; font-size: 24px; color: #1890ff"
        spin
      />
    </div>
    <div v-else class="accounts--container">
      <a-form :form="form" @submit="handleSubmit">
        <div v-if="figment.meta.accounts.length">
          <a-card v-for="(k, j) in figment.meta.accounts" :key="j">
            <div class="ant-card-head">
              <div class="ant-card-head-wrapper">
                <div class="ant-card-head-title">
                  <BaseIcon :name="['fab', k.platform]" />
                  {{ k.platform }}
                </div>
              </div>
            </div>

            <a-form-item>
              <a-row :gutter="16">
                <a-col :sm="16" :md="8" style="display: none">
                  <a-form-item label="Platform">
                    <a-select
                      v-decorator="[
                        `accounts_platform[${j}]`,
                        {
                          initialValue: k.platform,
                        },
                      ]"
                    >
                      <a-select-option
                        v-for="(s, i) in socials"
                        :key="i"
                        :value="s.toLowerCase()"
                      >
                        {{ s }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>

                <a-col :sm="16" :md="8">
                  <a-form-item label="Username">
                    <a-input
                      v-decorator="[
                        `accounts_platform_username[${j}]`,
                        {
                          initialValue: k.platform_username,
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>

                <a-col :sm="16" :md="8">
                  <a-form-item label="Password">
                    <a-input-password
                      v-decorator="[
                        `accounts_platform_password[${j}]`,
                        {
                          initialValue: k.platform_password,
                          rules: [
                            {
                              placeholder: 'Please input your password!',
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>

                <a-col :sm="16" :md="8">
                  <a-form-item label="Inactive">
                    <a-switch
                      v-decorator="[
                        `accounts_platform_status[${j}]`,
                        {
                          initialValue: k.platform_status,
                          valuePropName: 'checked',
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>

                <a-col :sm="16" :md="8">
                  <a-form-item label="Date Activated">
                    <a-date-picker
                      v-decorator="[
                        `accounts_platform_dateActivated[${j}]`,
                        {
                          initialValue: k.platform_dateActivated,
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>

                <a-col :sm="16" :md="8">
                  <a-form-item label="Date Inactivated">
                    <a-date-picker
                      v-decorator="[
                        `accounts_platform_dateInactivated[${j}]`,
                        {
                          initialValue: k.platform_dateInactivated,
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>

                <a-col :sm="16" :md="24">
                  <a-form-item label="Notes">
                    <a-textarea
                      v-decorator="[
                        `accounts_platform_notes[${j}]`,
                        {
                          initialValue: k.platform_notes,
                          rules: [
                            {
                              placeholder: 'Please input your notes!',
                            },
                          ],
                        },
                      ]"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form-item>
          </a-card>
        </div>

        <a-form-item v-for="k in form.getFieldValue('keys')" :key="k">
          <a-card>
            <a-row :gutter="16">
              <a-col :sm="16" :md="8">
                <a-form-item label="Platform">
                  <a-select v-decorator="[`platform[${k}]`]">
                    <a-select-option
                      v-for="(s, i) in socials"
                      :key="i"
                      :value="s.toLowerCase()"
                    >
                      {{ s }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

              <a-col :sm="16" :md="8">
                <a-form-item label="Username">
                  <a-input
                    v-decorator="[
                      `platform_username[${k}]`,
                      {
                        rules: [
                          {
                            placeholder: 'Please input your username!',
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>

              <a-col :sm="16" :md="8">
                <a-form-item label="Password">
                  <a-input
                    v-decorator="[
                      `platform_password[${k}]`,
                      {
                        rules: [
                          {
                            placeholder: 'Please input your password!',
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>

              <a-col :sm="16" :md="8">
                <a-form-item label="Inactive">
                  <a-switch
                    v-decorator="[
                      `platform_status[${k}]`,
                      {
                        valuePropName: 'status',
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>

              <a-col :sm="16" :md="8">
                <a-form-item label="Date Activated">
                  <a-date-picker
                    v-decorator="[`platform_dateActivated[${k}]`]"
                  />
                </a-form-item>
              </a-col>

              <a-col :sm="16" :md="8">
                <a-form-item label="Date Inactivated">
                  <a-date-picker
                    v-decorator="[`platform_dateInactivated[${k}]`]"
                  />
                </a-form-item>
              </a-col>

              <a-col :sm="16" :md="24">
                <a-form-item label="Notes">
                  <a-textarea
                    v-decorator="[
                      `platform_notes[${k}]`,
                      {
                        rules: [
                          {
                            placeholder: 'Please input your notes!',
                          },
                        ],
                      },
                    ]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>

          <a-popconfirm title="Sure to delete?" @confirm="() => removeItem(k)">
            <a href="javascript:;" title="Delete Account">
              <a-button type="danger" icon="delete" size="small"></a-button>
            </a>
          </a-popconfirm>
        </a-form-item>

        <a-form-item>
          <a-button type="dashed" style="width: 100%" @click="add">
            <a-icon type="plus" />
            Add Account
          </a-button>
        </a-form-item>

        <a-row class="submit--container">
          <a-col :sm="16" :md="8">
            <a-form-item>
              <a-button type="primary" html-type="submit"> Save</a-button>
            </a-form-item>
          </a-col>
          <a-col :sm="16" :md="3">
            <a-form-item>
              <a-button @click="$router.go(-1)"> Cancel</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </div>
</template>

<style lang="scss">
@import '@design';

.loader {
  padding: 2rem;
  text-align: center;
}

.button--container {
  width: 100%;
  margin-top: 8px;

  button {
    width: 100%;
  }
}

.form--container {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: white;
}

.accounts--container {
  height: 100%;
  max-height: calc(100vh - 18rem);
  overflow-y: scroll;

  .ant-card-head {
    margin: -12px;
    margin-bottom: 12px;
  }

  .ant-card {
    margin: 0.8rem auto;

    .ant-card-head {
      padding: 0 12px;
    }

    .ant-card-head-title {
      text-transform: uppercase;
      letter-spacing: 1px;

      svg {
        margin-right: 5px;
      }
    }
  }

  h5 {
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  button.ant-btn.ant-btn-circle.ant-btn-sm {
    position: absolute;
    top: -41px;
    right: 0;
    z-index: 1;
  }
}
</style>
